import { fromEventPattern } from 'rxjs/observable/fromEventPattern';
import { FromEventPatternObservable } from 'rxjs/observable/FromEventPatternObservable';

export const eventFromPatternTinyMCE = (editor, eventName: string): FromEventPatternObservable<any> => {
  let a = handler => {
    editor.on(eventName, handler);
  };
  return fromEventPattern(a);
};
